<template>
  <layout :showuserinfo="false" title="Cukai Tanah" :crumbs="crumbs">
    <w-alert
      error
      outline
      v-if="hasSearched && !cukai.no_hm && !cukai.no_kp && !cukai.no_resit"
      >Tiada hak milik ditemui.</w-alert
    >
    <z-page title="Semakan Cukai" :append-button="true" icon="fal fa-database">
      <w-flex class="justify-end">
        <div class="xs4 mr3"></div>
      </w-flex>
      <w-flex class="justify-end">
        <div class="xs4 mr3">
          <w-select
            class="mb3"
            :items="districts"
            v-model="form.kod_daerah"
            outline
            label="Pilih Daerah"
            label-position="left"
            @input="fetchData1()"
          >
          </w-select>
        </div>
      </w-flex>
      <w-tabs
        class=""
        :items="tabs"
        :no-slider="false"
        active-class="primary"
        @focus="focusTab"
      >
        <template #item-content.1>
          <w-form @submit.prevent="submit">
            <w-flex class="mt3">
              <div class="xs2">
                <w-radio
                  class="mr2"
                  v-model="form.form_option"
                  name="radio"
                  return-value="option1"
                >
                  Barcode
                </w-radio>
              </div>
              <div class="xs10 mr3">
                <w-input
                  v-model="form.barcode"
                  placeholder="Sila Masukkan Barcode"
                  :disabled="form.form_option !== 'option1'"
                  :validators="[validators.required]"
                  maxlength="30"
                ></w-input>
              </div>
            </w-flex>


            <w-flex class="mt3">
              <div class="xs2 mr3">
                <w-radio
                  v-model="form.form_option"
                  name="radio"
                  return-value="option2"
                >
                  ID Hakmilik
                </w-radio>
              </div>
              <div class="xs2 mr3">
                <z-lookup
                    v-if="renderComponent"
                    :url="apiBaseUrl + '/mukim?kod_daerah=' + form.kod_daerah"
                    :sort="false"
                    :cache="false"
                    v-model="form.kod_mukim"
                    placeholder="Sila Pilih Kod Mukim"
                    :disabled="form.form_option !== 'option2'"
                />
              </div>
              <div class="xs2 mr3">
                <z-lookup
                    v-if="renderComponent"
                    :url="apiBaseUrl + '/jenis-hm'"
                    :sort="false"
                    :cache="false"
                    v-model="form.kod_jenis_hm"
                    placeholder="Sila Pilih Jenis Hakmilik"
                    :disabled="form.form_option !== 'option2'"
                />
              </div>
              <div class="xs2 mr3">
                <w-input
                  v-model="form.no_hm"
                  :model-value="
                    form.form_option !== 'option2' ? '' : form.no_hm
                  "
                  placeholder="Sila Masukkan No. Hakmilik"
                  :disabled="form.form_option !== 'option2'"
                  :validators="[
                    form.form_option === 'option2' ? validators.required : null,
                  ]"
                >
                </w-input>
              </div>

              <div class="xs2 mr3"></div>
              <div class="xs2 mr3"></div>
            </w-flex>
            <w-flex class="mt3">
              <div class="xs2 mr3"></div>
              <div class="xs2 mr3">
                <w-input
                  v-model="form.no_bangunan"
                  :model-value="
                    form.form_option !== 'option2' ? '' : form.no_bangunan
                  "
                  placeholder="Bangunan"
                  :disabled="form.form_option !== 'option2'"
                >
                </w-input>
              </div>
              <div class="xs2 mr3">
                <w-input
                  v-model="form.no_tingkat"
                  :model-value="
                    form.form_option !== 'option2' ? '' : form.no_tingkat
                  "
                  placeholder="Tingkat"
                  :disabled="form.form_option !== 'option2'"
                >
                </w-input>
              </div>
              <div class="xs2 mr3">
                <w-input
                  v-model="form.no_petak"
                  :model-value="
                    form.form_option !== 'option2' ? '' : form.no_petak
                  "
                  placeholder="Petak"
                  :disabled="form.form_option !== 'option2'"
                >
                </w-input>
              </div>
              <div class="xs2 mr3"></div>
              <div class="xs2 mr3"></div>
            </w-flex>

            <w-flex class="mt3">
              <div class="xs2 mr3">
                <w-radio
                  v-model="form.form_option"
                  name="radio"
                  return-value="option3"
                >
                  Mukim dan No. Hakmilik
                </w-radio>
              </div>
              <div class="xs2 mr3">
                <z-lookup
                    v-if="renderComponent"
                    :url="apiBaseUrl + '/mukim?kod_daerah=' + form.kod_daerah"
                    :sort="false"
                    :cache="false"
                    v-model="form.kod_mukim"
                    placeholder="Sila Pilih Kod Mukim"
                    :disabled="form.form_option !== 'option3'"
                />
              </div>
              <div class="xs2 mr3">
                <w-input
                  :validators="[
                    form.form_option === 'option3' ? validators.required : null,
                  ]"
                  v-model="form.no_hm"
                  :model-value="
                    form.form_option !== 'option3' ? '' : form.no_hm
                  "
                  placeholder="Sila Masukkan No. Hakmilik"
                  :disabled="form.form_option !== 'option3'"
                >
                </w-input>
              </div>
              <div class="xs2 mr3"></div>
              <div class="xs2 mr3"></div>
              <div class="xs2 mr3"></div>
            </w-flex>
            <w-flex class="mt3">
              <div class="xs2 mr3"></div>
              <div class="xs2 mr3">
                <w-input
                  v-model="form.no_bangunan"
                  :model-value="
                    form.form_option !== 'option3' ? '' : form.no_bangunan
                  "
                  placeholder="Bangunan"
                  :disabled="form.form_option !== 'option3'"
                >
                </w-input>
              </div>
              <div class="xs2 mr3">
                <w-input
                  v-model="form.no_tingkat"
                  :model-value="
                    form.form_option !== 'option3' ? '' : form.no_tingkat
                  "
                  placeholder="Tingkat"
                  :disabled="form.form_option !== 'option3'"
                >
                </w-input>
              </div>
              <div class="xs2 mr3">
                <w-input
                  v-model="form.no_petak"
                  :model-value="
                    form.form_option !== 'option3' ? '' : form.no_petak
                  "
                  placeholder="Petak"
                  :disabled="form.form_option !== 'option3'"
                >
                </w-input>
              </div>
              <div class="xs2 mr3"></div>
              <div class="xs2 mr3"></div>
            </w-flex>

            <w-flex class="mt3">
              <div class="xs2 mr3">
                <w-radio
                  v-model="form.form_option"
                  name="radio"
                  return-value="option4"
                >
                  Jenis dan No. Hakmilik
                </w-radio>
              </div>
              <div class="xs2 mr3">
                <z-lookup
                    v-if="renderComponent"
                    :url="apiBaseUrl + '/jenis-hm'"
                    :sort="false"
                    :cache="false"
                    v-model="form.kod_jenis_hm"
                    placeholder="Sila Pilih Jenis Hakmilik"
                    :disabled="form.form_option !== 'option4'"
                />
              </div>
              <div class="xs2 mr3">
                <w-input
                  :validators="[
                    form.form_option === 'option4' ? validators.required : null,
                  ]"
                  v-model="form.no_hm"
                  :model-value="
                    form.form_option !== 'option4' ? '' : form.no_hm
                  "
                  placeholder="Sila Masukkan No. Hakmilik"
                  :disabled="form.form_option !== 'option4'"
                >
                </w-input>
              </div>
              <div class="xs2 mr3"></div>
              <div class="xs2 mr3"></div>
              <div class="xs2 mr3"></div>
            </w-flex>
            <w-flex class="mt3">
              <div class="xs2 mr3"></div>
              <div class="xs2 mr3">
                <w-input
                  v-model="form.no_bangunan"
                  :model-value="
                    form.form_option !== 'option4' ? '' : form.no_bangunan
                  "
                  placeholder="Bangunan"
                  :disabled="form.form_option !== 'option4'"
                >
                </w-input>
              </div>
              <div class="xs2 mr3">
                <w-input
                  v-model="form.no_tingkat"
                  :model-value="
                    form.form_option !== 'option4' ? '' : form.no_tingkat
                  "
                  placeholder="Tingkat"
                  :disabled="form.form_option !== 'option4'"
                >
                </w-input>
              </div>
              <div class="xs2 mr3">
                <w-input
                  v-model="form.no_petak"
                  :model-value="
                    form.form_option !== 'option4' ? '' : form.no_petak
                  "
                  placeholder="Petak"
                  :disabled="form.form_option !== 'option4'"
                >
                </w-input>
              </div>
              <div class="xs2 mr3"></div>
              <div class="xs2 mr3"></div>
            </w-flex>

            <w-flex class="mt3">
              <div class="xs2 mr3">
                <w-radio
                  v-model="form.form_option"
                  name="radio"
                  return-value="option6"
                >
                  No. Lot
                </w-radio>
              </div>
              <div class="xs2 mr3">
                <z-lookup
                    v-if="renderComponent"
                    :url="apiBaseUrl + '/mukim?kod_daerah=' + form.kod_daerah"
                    :sort="false"
                    :cache="false"
                    v-model="form.kod_mukim"
                    placeholder="Sila Pilih Kod Mukim"
                    :disabled="form.form_option !== 'option6'"
                />
              </div>
               <div class="xs2 mr3">
                <z-lookup
                    v-if="renderComponent"
                    :url="apiBaseUrl + '/jenis-lot'"
                    :sort="false"
                    :cache="false"
                    v-model="form.kod_lot"
                    placeholder="Sila Pilih Jenis Lot"
                    :disabled="form.form_option !== 'option6'"
                />
              </div>
              <div class="xs2 mr3">
                <w-input
                  v-model="form.no_lot"
                  :model-value="
                    form.form_option !== 'option6' ? '' : form.no_lot
                  "
                  placeholder="No. Lot"
                  :disabled="form.form_option !== 'option6'"
                >
                </w-input>
              </div>

              <div class="xs2 mr3"></div>
              <div class="xs2 mr3"></div>
            </w-flex>
            <div class="d-flex justify-end mt3">
              <w-button class="my1 mr0" type="submit" :loading="searching">
                Semak Cukai
              </w-button>
            </div>
          </w-form>
        </template>
        <template #item-content.2>
          <w-form method="post" @submit.prevent="searchCukai">
            <w-flex class="mt3">
              <w-input
                label="Sila Masukkan No Kad Pengenalan"
                v-model="form.no_kp"
                placeholder="No Kad Pengenalan"
                :validators="[validators.required]"
              ></w-input>
            </w-flex>
            <div class="d-flex justify-end mt3">
              <w-button class="my1 mr0" type="submit" :loading="searching">
                Semak Cukai
              </w-button>
            </div>
          </w-form>
          <p><span style="color:red;">*</span>Untuk carian secara terperinci, sila gunakan <strong>'%'</strong>&nbsp;pada carian. Contoh: 98050202%</p>
        </template>
        <template #item-content.3>
          <w-form method="post" @submit.prevent="searchCukai">
            <w-flex class="mt3">
              <w-input
                label="Sila Masukkan Nama Pemilik"
                v-model="form.nama"
                placeholder="Nama Pemilik"
                :validators="[validators.required]"
              ></w-input>
            </w-flex>
            <!-- <div class="d-flex justify-end mt3">
              <w-button class="my1 mr0" @click='cetakPemilik' :loading="searching">
                Cetak Pemilik
              </w-button>
              <w-button class="my1 mr0" type="submit" :loading="searching">
                Semak Cukai
              </w-button>
            </div> -->
            <div class="mt2 text-right">
                <w-button
                bg-color="success"
                class="ml1"
                :loading="loading" @click="cetakPemilik()">
                <w-icon v-on="on" class=" mr2 "> fal fa-print</w-icon>
                    &nbsp;Cetak&nbsp;
                </w-button>

                <w-button
                bg-color="primary"
                class="ml1 "
                type="submit"
                :loading="searching"
                >
                    <w-icon>fal fa-search</w-icon>&nbsp;Semak Cukai
                </w-button>
            </div>
          </w-form>
                 <p><span style="color:red;">*</span>Untuk carian secara terperinci, sila gunakan <strong>'%'</strong>&nbsp;pada carian. Contoh: Muhammad %Izudin B% Osman</p>
        </template>
        <template #item-content.4>
          <w-form method="post" @submit.prevent="searchCukai">
            <w-flex class="mt3">
              <w-input
                label="Sila Masukkan No Resit"
                v-model="form.no_resit"
                placeholder="No Resit"
                :validators="[validators.required]"
              ></w-input>
            </w-flex>
            <div class="d-flex justify-end mt3">
              <w-button class="my1 mr0" type="submit" :loading="searching">
                Semak Cukai
              </w-button>
            </div></w-form
          >
            <p><span style="color:red;">*</span>Untuk carian secara terperinci, sila gunakan <strong>'%'</strong>&nbsp;pada carian. Contoh: RTK2021%1234</p>
        </template>
        <template #item-content.5>
            <SemakanSptb
            :daerah="this.form.kod_daerah">

            </SemakanSptb>
        </template>
      </w-tabs>
    </z-page>

    <!-- <h4
            v-if="
                hasSearched && !cukai.no_hm && !cukai.no_kp && !cukai.no_resit
            "
            class="ma1"
        >
            Tiada Rekod Ditemui
        </h4> -->

    <w-card v-if="form.kategori_carian === 2" bg-color="" class="mt3 sh2">
      <nokp :cukais="cukais" :cukai="cukai" />
    </w-card>
    <w-card v-else-if="form.kategori_carian === 3" class="mt3 sh2">
      <namapemilik :cukais="cukais" />
    </w-card>
    <w-card v-else-if="form.kategori_carian === 4" bg-color="" class="mt3 sh2">
      <noresit :cukais="cukais" />
    </w-card>

    <w-dialog
    :model-value="cukaiTrue"
    :width="600"
    title-class="primary-light1--bg white"
    >
        <table
        class="table-dashboard"
        width="100%">
            <thead>
            <tr>
                <td>Bil</td>
                <td>No Hak Milik</td>
                <td>Status</td>
                <td>Tindakan</td>
            </tr>
            </thead>

        <tbody >
            <tr v-for="(cukais,index) in cukais">
                <td>{{ index+1}}</td>
                <td>{{ cukais.no_hm }}</td>
                <td>{{ cukais.status_hm}}</td>
                <td>
                    <w-button class="ml3" :loading="searching" type="submit" @click='butiranCukai(cukais.no_hm )'> Butiran Cukai </w-button>
                </td>
            </tr>
        </tbody>
        </table>
        <w-flex class="px6" v-if="$zutil.can('Kemaskini Hakmilik')">
            <div class="spacer" />
            <w-button
                :loading="searching"
                text
                @click="cukaiTrue=false"
            >
                Batal
            </w-button>
        </w-flex>
    </w-dialog>
  </layout>
</template>

<script>
import ZResource from "@/Modules/z-resource";
import Hakmilik from "../Component/Hakmilik";
import Card from "../Component/Card";
import Nokp from "../Component/Nokp";
import Noresit from "../Component/Noresit";
import Namapemilik from "../Component/Namapemilik";
import { Inertia } from "@inertiajs/inertia";
import SemakanSptb from '../Component/SemakanSptb'
import WaveUI from "wave-ui";
export default {
  extends: ZResource,
  components: {
    Hakmilik,
    Card,
    Nokp,
    Noresit,
    Namapemilik,
    SemakanSptb,
  },
  props: {},
  data() {
    return {
        cukaiTrue:false,
      waveui: new WaveUI(),
      validators: {
        required: (value) => !!value || "Sila Isi Ruangan Ini",
        // Other validators...
      },
      resourceurl: "cukai-tanah",
      apiBaseUrl: process.env.MIX_API_BASE_URL,
      reload: true,
      crumbs: [
        { label: this.$page.props.app_name, route: "/sitemap" },
        { label: "Cukai Tanah", route: "/cukai-tanah/dashboard" },
        { label: "Senarai", route: "/cukai-tanah/senarai" },
      ],
      tabs: [
        { id: 1, title: "ID Hakmilik", content: "" },
        {
          id: 2,
          title: "No. Pengenalan Pengenalan / Tentera / Polis / SSM",
          content: "",
        },
        { id: 3, title: "Nama Pemilik", content: "" },
        { id: 4, title: "No. Resit", content: "" },
        { id: 5, title: "Semakan Dari SPTB", content: "" },
      ],

      districts: [{ label: "Loading", selected: true }],
      mukim: [{ label: "Loading", selected: true }],
      jhm: [{ label: "Loading", selected: true }],
      kod_lot: [{ label: "Loading", selected: true }],
      form: {
        kod_daerah: "01",
        form_option: "option1",
        kategori_carian: "1",
        barcode: null,
        kod_mukim: null,
        kod_lot: null,
        kod_jenis_hm: null,
        no_hm: "",
        no_bangunan: null,
        no_tingkat: null,
        no_petak: null,
        no_resit: null,
        no_kp: null,
        no_akaun: null
      },
      search: {
        keyword: "",
        is_cukai_tanah: "",
      },
      searching: false,
      hasSearched: false,

      cukai: [],
      cukais: [],
      renderComponent: false,
      jabatan: {}
    };
  },
  setup() {},
  methods: {
    forceRerender() {
        // Remove my-component from the DOM
        this.renderComponent = false;

        this.$nextTick(() => {
          // Add the component back in
          this.renderComponent = true;
        });
      },
      butiranCukai($x){
        this.searching = true;
        const url = `butiran-cukai?no_hm=${$x}`;
             this.$inertia.get(url);
             this.searching = false;
      },
    async submit() {
      if (this.form.barcode != null || this.form.no_hm != null) {
        this.cukai = [];
        this.hasSearched = false;
        this.searching = true;
        const temp = this.jhm.find(e => e.id == this.form.kod_jenis_hm);
        this.form.kod_jenis_hm = temp ? temp.kod : null;

        const temp2 = this.kod_lot.find(e => e.value == this.form.kod_lot);
        this.form.kod_lot = temp2 ? temp2.keterangan : null;

        await axios({
          method: "post",
          url: `${this.apiBaseUrl}/cukai/cari`,
          responseType: "json",
          data: this.form,
        })
          .then((e) => {
            if (e.data.length > 1) {
              this.cukai = e.data[0];
              this.cukais = e.data;
              this.$waveui.notify({
                error: false,
                message: "Hak Milik Wujud",
                timeout: 3000,
              });
              this.cukaiTrue=true;
              return;
            }
            if (e.data.length > 0) {
              this.cukai = e.data[0];
              this.cukais = e.data;

              const url = `butiran-cukai?no_hm=${this.cukai.no_hm}`;
            //   console.log(url);
             this.$inertia.get(url);
            //   location.href(`cukai-tanah/butiran-cukai?no_hm=${this.cukai.no_hm}`);
            //   window.open(url,'_blank');
            }
          })
          .finally((e) => {
            this.searching = false;
            this.hasSearched = true;
          });
      } else {
        console.log("no data");
      }
    },
    focusTab(e) {
      this.form.kategori_carian = e.id;
    },

    async fetchData4() {
      await axios({
        method: "get",
        url: `${this.apiBaseUrl}/daerah`,
        responseType: "json",
      }).then((e) => {
        this.districts = e.data.map((d) => {
          return {
            label: d.kod + " - " + d.keterangan,
            value: d.kod,
          };
        });
      });
    },
    async fetchData() {
      await axios({
        method: "get",
        url: `${this.apiBaseUrl}/jabatan/${this.$page.props.auth.user.jabatan_id}`,
        responseType: "json",
      }).then((e) => {
        this.jabatan = e.data
        this.form.kod_daerah = e.data.jabatan_daerah.daerah.kod
      }).catch(err => {
        console.log(err)
      });
    },
    async fetchData3() {
      await axios({
        method: "post",
        url: `${this.apiBaseUrl}/jenis-lot`,
        responseType: "json",
      }).then((e) => {
        this.kod_lot = e.data
      });
    },

    async searchCukai() {
      this.cukai = [];
      this.hasSearched = false;
      this.searching = true;

      await axios({
        method: "post",
        url: `${this.apiBaseUrl}/cukai/cari`,
        responseType: "json",
        data: this.form,
      })
        .then((e) => {
          if (e.data.length > 0) {
            this.cukai = e.data[0];
            this.cukais = e.data;
          }
        })
        .finally((e) => {
          this.searching = false;
          this.hasSearched = true;
        });
    },
    async fetchData2() {
      await axios({
        method: "get",
        url: `${this.apiBaseUrl}/jenisHm`,
        responseType: "json",
      }).then((e) => {
        this.jhm = e.data
      });
    },
    async fetchData1() {
        this.forceRerender();
        this.form.kod_mukim = null;
    },

    async cetakPemilik(){
        var nama = encodeURIComponent(this.form.nama)
        window.open( `${this.apiBaseUrl}/cukai/cetakPemilik?nama=${nama}&kod_daerah=${this.form.kod_daerah}`);
    },
    async init() {
      const res = await this.fetchData();
      const res2 = await this.fetchData2();
      const res3 = await this.fetchData3();
      const res4 = await this.fetchData4();
      const res1 = await this.fetchData1();
    },
  },

  mounted() {
    this.init();
  },
};
</script>
<style>
  .w-select--disabled .w-select__selection::placeholder{
    color: #ccc;
  }
</style>
